<template>
  <div>
    <Form
      page-title="Add a new Category"
      buttonName="Submit"
      :isCreateMode="true"
      :businessId="businessId"
      :isInList="isInList"
      @submit="submit"
      ref="CategoriesForm"
      :loading="loading"
    />
  </div>
</template>
<script>
import Form from "./Form";
import { createCategory } from "@/API/CategoriesAPIs";
import { submitAndNotify } from "@/helpers/utils";
export default {
  name: "Create",
  props: ["isInList", "businessId"],
  components: { Form },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async submit(formData) {
      const callback = () => {
        this.$refs.CategoriesForm.resetForm();
      };
      submitAndNotify(this, createCategory(formData), callback);
    }
  }
};
</script>
<style></style>
